import { apiBackendBaseUrl } from "@settings/env";

export const enableMocking = async () => {
  if (!import.meta.env.VITE_ENABLE_API_MOCKS) return;
  if (import.meta.env.MODE === "test") return;

  const { worker } = await import("./browser");
  return worker.start({
    onUnhandledRequest(req, print) {
      if (!req.url.includes(apiBackendBaseUrl)) return;
      print.warning();
    },
  });
};
